import type { EntityAction } from "@firecms/core";
import { PersonOffIcon } from "@firecms/ui";
import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import type { EventUser } from "../collections/eventUsers";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import { tableOnlyEntityAction } from "./entityActionDefaults";
import { openConfirmTextAction } from "./openConfirmTextAction";

export function buildRemoveUserFromEventEntityAction(
  accountId: string,
  eventId: string
): EntityAction<EventUser> {
  const t = getAdminT(getAdminUiLocale());

  return {
    key: "remove-user-from-event",
    name: t("removeUserFromEvent.entityAction"),
    icon: <PersonOffIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: ({ entity, context }) => {
      if (!entity) {
        return;
      }

      const userId = entity.values.uid || entity.id;

      openConfirmTextAction(context, {
        key: `remove-user-from-event-${entity.id}`,
        title: t("removeUserFromEvent.title"),
        body: t("removeUserFromEvent.body"),
        onConfirm: async () => {
          try {
            const functions = getFunctions(getApp());
            const callable = httpsCallable(functions, "removeUserFromEvent");
            await callable({ accountId, eventId, userId });
            context.snackbarController.open({
              type: "success",
              message: t("removeUserFromEvent.success"),
            });
            return true;
          } catch (error: unknown) {
            const message =
              error instanceof Error
                ? error.message
                : t("common.unknownError");
            context.snackbarController.open({
              type: "error",
              message: t("removeUserFromEvent.error", { message }),
            });
            console.error(error);
            return false;
          }
        },
      });
    },
  };
}
